<template>
    <div>
        <!-- Button trigger modal -->
        <button :id="tipousuario+'infoModalBtn'" type="button" class="btn btn-primary invisible" data-bs-toggle="modal"
            :data-bs-target="'#infoMessage'+tipousuario">
        </button>
        <transition name="modal-fade">
            <!-- Modal -->
            <div class="modal fade" :id="'infoMessage'+tipousuario" tabindex="-1" aria-labelledby="infoMessageLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header utel-modal-header">
                            <h3 class="modal-title" id="infoMessageLabel"><strong>{{ info.title }}</strong></h3>
                            <button type="button" class="btn btn-close bg-utel-v2-secondary active" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body utel-modal-content">
                            <h4>{{ info.content }}</h4>
                        </div>
                        <div class="modal-footer justify-content-center" style="font-size: 12px;">
                            <button type="button" class="btn btn-utel text-light" data-bs-dismiss="modal">Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </transition> 
    </div>
</template>

<script>
    export default {
        props: ["info", "tipousuario"],
        data() {
            return {
                
            }
        }
    }
</script>
<style>
    .utel-modal-header{
        background-color: #E0E2FF;
        color: #1A0054;
    }
    .utel-modal-content{
        color: #494949;
        line-height: 30px;
        font-family: sans-serif;
    }
</style>